import React from "react";
import { CheckIcon, TrophyIcon, InfoIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { volumes } from "../data/content";
export function Volumes() {
  return <section className="w-full bg-white px-5 py-16 sm:py-20" data-id="element-287" data-mp="185q4pzhxajxj">
      <SectionHeading eyebrow="What You'll Find Inside" title={<>
            Six Professional Volumes <span className="text-brand" data-id="element-289" data-mp="1zwcnb0bwnv9b">Designed to Work Together</span>
          </>} data-id="element-288" data-mp="1c4p7pek3g6mc" />
      <p className="mx-auto mt-5 max-w-2xl text-center text-lg leading-relaxed text-muted" data-id="element-290" data-mp="24suoxrbxvdhf">
        Each volume addresses a different stage of the investigation, from identifying the initial symptoms to
        documenting your findings and reviewing the outcome.
      </p>

      <div className="mx-auto mt-10 max-w-3xl space-y-6" data-id="element-291" data-mp="feyah7kf45cu">
        {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl border border-navy/10 bg-canvas" data-id="element-292" data-mp="keu6okmvishu">
            <div className="flex items-center gap-4 px-5 py-5 sm:px-8" style={{
          backgroundColor: v.color
        }} data-id="element-293" data-mp="3o7dev8xn6ype">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white font-display text-xl font-black" style={{
            color: v.color
          }} data-id="element-294" data-mp="3ja54huiqjyyp">
                {v.number}
              </span>
              <div data-id="element-295" data-mp="3t5omre4dmz4z">
                <p className="text-xs font-extrabold uppercase tracking-wider text-white/85" data-id="element-296" data-mp="3t9ch2fhnbpkr">Volume {v.number}</p>
                <h3 className="font-display text-xl font-black leading-tight text-white sm:text-2xl" data-id="element-297" data-mp="azad3rd55bce">{v.title}</h3>
              </div>
            </div>
            <div className="px-5 py-6 sm:px-8" data-id="element-298" data-mp="kq4x0p2wzyuo">
              <p className="text-base leading-relaxed text-muted" data-id="element-299" data-mp="fsd69ye0ais2">{v.intro}</p>
              <p className="mt-5 text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-300" data-mp="fug6fb8vhsai">Inside, you'll find:</p>
              <ul className="mt-3 space-y-2.5" data-id="element-301" data-mp="tprxn8ntl0mo">
                {v.items.map(item => <li key={item} className="flex gap-3 text-base leading-snug text-navy" data-id="element-302" data-mp="pogad9sf4rhn">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full" style={{
                backgroundColor: v.color
              }} data-id="element-303" data-mp="wrmq1qs70tmb">
                      <CheckIcon className="h-3.5 w-3.5 text-white" aria-hidden="true" data-id="element-304" data-mp="16rdou4nsdus7" />
                    </span>
                    {item}
                  </li>)}
              </ul>
              <div className="mt-6 flex gap-3 rounded-2xl bg-white p-4" data-id="element-305" data-mp="1fl0dzbxhnzsf">
                <TrophyIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-306" data-mp="1kjblvh484080" />
                <p className="text-base leading-snug text-navy" data-id="element-307" data-mp="1pieutcnbqql9">
                  <strong data-id="element-308" data-mp="1piy464yws6no">The result:</strong> {v.result}
                </p>
              </div>
              {v.note && <p className="mt-4 flex gap-2 text-sm leading-relaxed text-muted" data-id="element-309" data-mp="1uf5ahyv7vk65">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-310" data-mp="3rbmawoarhc87" />
                  {v.note}
                </p>}
            </div>
          </article>)}
      </div>

      <div className="mt-12" data-id="element-311" data-mp="2dfum9wxgthrc">
        <CtaButton data-id="element-312" data-mp="28n9uf0y4deqg">Yes! I Want All Six Volumes</CtaButton>
      </div>
    </section>;
}